import { Helmet } from "react-helmet-async";

/**
 * Simple centered content page — no sidebars or discovery rails.
 */
export default function ContentPage({
  children,
  className = "",
  title,
  narrow = false,
}) {
  return (
    <div className={`content-page${className ? ` ${className}` : ""}`}>
      {title && (
        <Helmet>
          <title>{title} – PeerPoetry</title>
        </Helmet>
      )}
      <div
        className={`content-page__inner${
          narrow ? " content-page__inner--narrow" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
}
